import { ArchiveResource } from "@skinsoft/types"
import { dbCacheDown } from "../dexie/cache-down"
import { STATS_KEYS } from "../dexie/stats-keys"
import { OfflineDataFetcher } from "@skinsoft/offline"

// @ts-ignore
export class ArchiveOfflineDataFetcher extends OfflineDataFetcher<ArchiveResource> {
    constructor() {
        super(dbCacheDown.archive, STATS_KEYS.archive)
    }
}